module.exports = __webpack_public_path__ + "img/business_deal.766fa6fb.png";